import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import {darkTheme} from "../reset-css";

export const StyledAudio = styled.div`
  display: flex;
  //margin-bottom: 1em;
  cursor: pointer;
  // font-weight: ${({ theme }) => theme === darkTheme ? '450' : 'initial'};
  @media (hover: hover) {
    &:hover {
      //.linear-wipe {
      //  background: unset;
      //  background-size: unset;
      //  background-clip: unset;
      //  text-fill-color: unset;
      //  -webkit-background-clip: unset;
      //  -webkit-text-fill-color: unset;
      //  animation: unset;
      //}
      color: ${themeGet('colors.primary', '#2251ff')};
    }
  }
  
  //svg {
  //  width: 1.7em;
  //  height: 1.7em;
  //}
  
  #pause-button {
    position: absolute;
    visibility: hidden;
  }
  
  &.playing {
    #play-button {
      visibility: hidden; /* Show play icon when not playing */
    }
    #pause-button {
      visibility: visible;
    }
  }
  // &.wipe-dark {
  //             background: linear-gradient(70deg,
  //     white 40%,
  //     ${themeGet('colors.primary', '#2251ff')} 50%,
  //     white 60%);
  //     opacity: ${({ theme }) => theme === darkTheme ? '1' : '0'};
  // } 
  // &.wipe-light {
  //   background: linear-gradient(70deg,
  //     black 40%,
  //     ${themeGet('colors.primary', '#2251ff')} 50%,
  //     black 60%);
  //     opacity: ${({ theme }) => theme === darkTheme ? '0' : '1'};
  // }    
  //     &.linear-wipe {
  //     //text-align: center;
  //     background-size: 300% auto;
  //     background-clip: text;
  //     text-fill-color: transparent;
  //     -webkit-background-clip: text;
  //     -webkit-text-fill-color: transparent;
  //     animation: shine 6s linear infinite;
  //     @keyframes shine {
  //     80% {
  //       background-position: -200%;
  //     }
  //     100% {
  //       background-position: -200%;
  //     }
  //     }
  // }
`;

export const PostDate = styled.span`
  //display: block;
  margin: auto 10px auto 10px;
  font-size: ${themeGet('fontSizes.3', '15')}px;
  color: ${({ theme }) => theme.foreground};
  text-transform: uppercase;
  @media (max-width: 780px) {
    font-size: 14px;
  }
  @media (max-width: 400px) {
    font-size: 13px;
  }
  @media (max-width: 550px) {
    @media (min-width: 400px) {
       span {
          display: none; /* Hide "Listening time:" */
        }   
    }
  }
`;

export const AudioWrapper = styled.div`
  //position: relative;
  //height: 50px;
  div {
      position: absolute;
  }
  &:hover {
    .linear-wipe {
      //transition: color .2s ease-in;
      background: unset;
      -webkit-background-clip: unset;
      -webkit-text-fill-color: unset;
      color: ${themeGet('colors.primary', '#2251ff')} !important;
    }
  }
`;
